<template>
    <div>
        <b-row v-if="$store.state.chat.editingMessage" class="message-input">
            <b-col xs="6" sm="6" md="8" lg="10" xl="10" cols="8"><base-textarea :rows="1" :max-rows="5" class="message-text" v-model="$store.state.chat.newMessage" :placeholder="$t('chats.new-message')"></base-textarea></b-col>
            <b-col xs="3" sm="3" md="2" lg="1" xl="1" cols="2" class="chat-input-buttons"><button class="icon-btn" @click="$store.dispatch('chat/editMessage')"><b-icon-check-lg class="icon"></b-icon-check-lg></button></b-col>
            <b-col xs="3" sm="3" md="2" lg="1" xl="1" cols="2" class="chat-input-buttons"><button class="icon-btn cancel" @click="$store.commit('chat/resetMsg')"><b-icon-x-lg class="icon"></b-icon-x-lg></button></b-col>
        </b-row>
        <b-row v-else-if="recordingAudio" class="message-input">
            <b-col xs="6" sm="6" md="8" lg="10" xl="10" cols="8"><div class="recorder"><span><b-icon-circle-fill class="recording icon" animation="throb"></b-icon-circle-fill>{{ formattedTime }}</span></div></b-col>
            <b-col xs="3" sm="3" md="2" lg="1" xl="1" cols="2" class="chat-input-buttons"><button class="icon-btn cancel" @click="cancelRecording()"><b-icon-trash-fill class="icon"></b-icon-trash-fill></button></b-col>
            <b-col xs="3" sm="3" md="2" lg="1" xl="1" cols="2" class="chat-input-buttons"><button class="icon-btn" @click="sendAudio()"><b-icon-cursor-fill class="icon"></b-icon-cursor-fill></button></b-col>
        </b-row>
        <b-row v-else class="message-input">
            <b-col xs="6" sm="6" md="8" lg="10" xl="10" cols="8"><base-textarea :rows="1" :max-rows="5" class="message-text" v-model="$store.state.chat.newMessage" :placeholder="$t('chats.new-message')"></base-textarea></b-col>
            <b-col xs="3" sm="3" md="2" lg="1" xl="1" cols="2" class="chat-input-buttons"><button class="icon-btn" @click="$refs.fileInput.click()"><b-icon-paperclip class="icon"></b-icon-paperclip><input type="file" ref="fileInput" @change="uploadFile($event.target.files[0])" class="d-none"/></button></b-col>
            <b-col xs="3" sm="3" md="2" lg="1" xl="1" cols="2" class="chat-input-buttons">
              <button class="icon-btn" @click="$store.dispatch('chat/sendMessage')" v-if="$store.state.chat.newMessage !== ''"><b-icon-cursor-fill class="icon"></b-icon-cursor-fill></button>
              <button class="icon-btn" @click="startRecording()" v-else><b-icon-mic-fill class="icon"></b-icon-mic-fill></button>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { BIcon } from 'bootstrap-vue'
import BaseTextarea from '@/components/base/forms/BaseTextarea.vue'

export default {
    components: {
        BIcon,
        BaseTextarea
    },
    data () {
        return {
            recordingAudio: false,
            cancelAudio: false,

            mediaRecorder: null,
            audioChunks: [],
            startTime: null,
            elapsedTime: 0,
            intervalId: null
        }
    },
    methods: {
        async uploadFile (file) {
            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => {
                let encoded = reader.result.toString().replace(/^data:(.*,)?/, '')
                if ((encoded.length % 4) > 0) {
                    encoded += '='.repeat(4 - (encoded.length % 4))
                }
                resolve(encoded)
                }
                reader.onerror = error => reject(error)
            })
            if (file) {
                var fileData = {
                name: file.name,
                contentType: file.type,
                Base64: await toBase64(file)
                }
                this.$store.dispatch('chat/sendMessage', fileData)
            } else {
                this.$store.dispatch('showDangerAlert', this.$t('chats.cant-upload-file'))
            }
        },
        startRecording () {
            this.$store.commit('chat/toggleShowMsgOptions')

            navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
                this.recordingAudio = true
                this.audioChunks = []
                this.startTimer()
                this.mediaRecorder = new MediaRecorder(stream)
                this.mediaRecorder.start()

                this.mediaRecorder.ondataavailable = event => {
                    this.audioChunks.push(event.data)
                }
                this.mediaRecorder.onstop = this.onStopRecording
            })
        },
        onStopRecording () {
            if (this.cancelAudio) {
                this.audioChunks = []
                this.cancelAudio = false
                return
            }
            const audioBlob = new Blob(this.audioChunks, { type: 'audio/mpeg' })
            const audioFile = new File([audioBlob], 'recording.mpeg', { type: 'audio/mpeg' })
            this.uploadFile(audioFile)
        },
        sendAudio () {
            if (!this.recordingAudio) return
            this.recordingAudio = false
            this.mediaRecorder.stop()
            this.stopTimer()
        },
        cancelRecording () {
            if (!this.recordingAudio) return
            this.recordingAudio = false
            this.cancelAudio = true
            this.mediaRecorder.stop()
            this.stopTimer()
        },
        startTimer () {
            this.startTime = Date.now()
            this.intervalId = setInterval(() => {
                this.elapsedTime = Math.floor((Date.now() - this.startTime) / 1000)
            }, 1000)
        },
        stopTimer () {
            clearInterval(this.intervalId)
            this.elapsedTime = 0
        }
    },
    computed: {
        formattedTime () {
            const minutes = Math.floor(this.elapsedTime / 60)
            const seconds = this.elapsedTime % 60
            return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
        }
    }
}
</script>
<style lang="scss" scoped>
.message-input {
  width: 100%;
  z-index: 2;
  display: flex;
  align-items: center;
  padding-left: 1rem;

  /deep/  .message-text textarea {
    background: $secondary;
    box-sizing: border-box;
    text-align: left;
  }

  /deep/ .message-text textarea::placeholder {
      display: flex;
    }

  .message-text::-webkit-scrollbar {
    display: none;
  }

  .chat-input-buttons {
    display: flex;
    justify-content: center;
    margin-bottom: 1.5rem;
  }

  .icon-btn {
    background: $blue;
    color: $white;
    border-radius: 50%;
    width: 3rem;
    height: 3rem;
    border: none;
    cursor: pointer;
    padding: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .recorder {
    margin-bottom: 1.5rem;
    height: 61px;
    display: flex;
    align-items: center;

    span {
      position: absolute;
      right: 0;
      padding-right: 1rem;
    }

    .recording.icon {
      color: $red;
    }
  }

  .icon-btn.cancel {
    background: $red;
  }
}

.icon {
  height: 1.3rem;
  width: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/views/chat-interconsultations/ChatMessageInput.vue